import { type FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { authSlice } from '../../core/auth/auth.slice';
import { AppRoute } from '../../routes';

export type LogoutPageProps = {
  children?: never;
};

export const LogoutPage: FunctionComponent<LogoutPageProps> = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      authSlice.actions.logoutRequested({
        reason: `Navigated to ${AppRoute['/logout']}`,
        requestor: 'LogoutPage',
      }),
    );
  }, [dispatch]);

  return null;
};
